<template>
    <section>
        <!--工具条-->
        <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        <!--列表-->
        <el-table :data="datalist"
                  highlight-current-row
                  @current-change="selectCurrentRow"
                  v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%">
            <el-table-column type="selection" width="50"></el-table-column>
            <!--<el-table-column type="index"  width=""></el-table-column>-->
            <el-table-column prop="sort" label="排序" width="" sortable></el-table-column>
            <el-table-column prop="id" label="ID" width="" sortable></el-table-column>
            <el-table-column prop="name" label="名称" width="" sortable></el-table-column>
            <el-table-column prop="categoryName" label="分类" width="" sortable></el-table-column>
            <el-table-column prop="storeName" label="店铺" width="" sortable></el-table-column>
            <el-table-column prop="price" label="价格" width="" sortable></el-table-column>
            <el-table-column prop="stock" label="库存" width="" sortable></el-table-column>
            <el-table-column prop="rebate" label="返利" width="" sortable></el-table-column>
            <!--状态-->
            <el-table-column prop="isMarketable" label="状态" width="" sortable>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.isMarketable ? 'success' : 'danger'"
                            disable-transitions>
                        {{ scope.row.isMarketable ? "上架" : "下架" }}
                    </el-tag>
                </template>
            </el-table-column>
            <!--类型-->
            <el-table-column prop="goodsType" label="类型" width="" sortable>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.goodsType == 1 ? 'success' : scope.row.goodsType == 2 ?'danger' : '' "
                            disable-transitions>
                        {{ scope.row.goodsType == 1 ? "普通商品" : scope.row.goodsType == 2 ? "接龙商品" : "默认" }}
                    </el-tag>
                </template>
            </el-table-column>
            <!--<el-table-column v-if="!isMarketable" prop="uptime" label="上架时间" wdth="" sortable></el-table-column>
            <el-table-column v-else prop="downtime" label="下架时间" width="" sortable></el-table-column>-->
            <el-table-column prop="updateTime" label="更新时间" width="160" sortable></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" sortable></el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next"
                           @current-change="handleCurrentChange"
                           :page-size="limit"
                           :total="total"
                           style="float: right">
            </el-pagination>
        </el-col>


        <!--新增界面-->
        <el-dialog title="新增"
                   :visible.sync="addFormVisible"
                   v-model="addFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="addForm"
                     label-width="80px"
                     :rules="addFormRules"
                     ref="addForm">
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="addForm.sort" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="addForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="image">
                    <el-upload class="avatar-uploader"
                               action="/api/picture"
                               :show-file-list="false"
                               :on-success="handleAvatarSuccess"
                               :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item prop="categoryIdArr" label="分类" width sortable>
                    <el-cascader placeholder="请选择，支持搜索功能"
                                 style="width: 400px"
                                 v-model="addForm.categoryIdArr"
                                 :options="categorys"
                                 filterable
                                 :key="isResouceShow"
                                 :props="{ checkStrictly: true, expandTrigger: 'hover' }"
                                 v-if="!addLoading"></el-cascader>
                    <el-cascader placeholder="加载中..."
                                 style="width: 400px"
                                 v-if="addLoading"></el-cascader>
                </el-form-item>

                <el-form-item prop="storeId" label="店铺">
                    <el-select v-model="addForm.storeId" filterable placeholder="请选择">
                        <el-option v-for="item in storeSeletctList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="简介" prop="brief">
                    <el-input v-model="addForm.brief" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="售价" prop="price">
                    <el-input v-model="addForm.price" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="进货价" prop="costPrice">
                    <el-input v-model="addForm.costPrice" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="返利" prop="rebate">
                    <el-input v-model="addForm.rebate" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="库存" prop="stock">
                    <el-input v-model="addForm.stock" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="图片集" prop="images">
                    <el-upload action="/api/picture"
                               list-type="picture-card"
                               :on-preview="handlePictureCardPreview"
                               :on-remove="handleRemove"
                               :on-success="handleImagesSuccess"
                               :before-upload="beforeAvatarUpload">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="状态" prop="isMarketable">
                    <el-radio-group v-model="addForm.isMarketable">
                        <el-radio :label="true">上架</el-radio>
                        <el-radio :label="false">下架</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="类型" prop="goodsType">
                    <el-radio-group v-model="addForm.goodsType">
                        <el-radio :label="1">普通商品</el-radio>
                        <el-radio :label="2">接龙商品</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker v-model="addForm.startTime"
                                    type="datetime"
                                    placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker v-model="addForm.endTime"
                                    type="datetime"
                                    placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="规格" prop="spec">
                    <el-input v-model="addForm.spec" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="产地" prop="place">
                    <el-input v-model="addForm.place" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="包装" prop="packing">
                    <el-input v-model="addForm.packing" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="商品详情" prop="intro">
                    <Tinymce ref="editor" :height="500" />
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="addSubmit"
                           :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>


        <!--编辑界面-->
        <el-dialog title="编辑"
                   :visible.sync="editFormVisible"
                   v-model="editFormVisible"
                   :close-on-click-modal="false">
            <el-form :model="editForm"
                     label-width="80px"
                     :rules="editFormRules"
                     ref="editForm">
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="editForm.sort" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="editForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="image">
                    <el-upload class="avatar-uploader"
                               action="/api/picture"
                               :file-list="fileList"
                               :show-file-list="false"
                               :on-success="handleAvatarSuccess"
                               :before-upload="beforeAvatarUpload">
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item prop="categoryIdArr" label="分类" width sortable>
                    <el-cascader placeholder="请选择，支持搜索功能"
                                 style="width: 400px"
                                 v-model="editForm.categoryIdArr"
                                 :options="categorys"
                                 filterable
                                 :key="isResouceShow"
                                 :props="{ checkStrictly: true, expandTrigger: 'hover' }"
                                 v-if="!addLoading"></el-cascader>
                    <el-cascader placeholder="加载中..."
                                 style="width: 400px"
                                 v-if="addLoading"></el-cascader>
                </el-form-item>
                <el-form-item prop="storeId" label="店铺">
                    <el-select v-model="editForm.storeName" filterable placeholder="请选择">
                        <el-option v-for="item in storeSeletctList"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="简介" prop="brief">
                    <el-input v-model="editForm.brief" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="售价" prop="price">
                    <el-input v-model="editForm.price" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="进货价" prop="costPrice">
                    <el-input v-model="editForm.costPrice" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="返利" prop="rebate">
                    <el-input v-model="editForm.rebate" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="库存" prop="stock">
                    <el-input v-model="editForm.stock" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="图片集" prop="images">
                    <el-upload action="/api/picture"
                               list-type="picture-card"
                               :file-list="fileList"
                               :on-preview="handlePictureCardPreview"
                               :on-remove="handleRemove"
                               :on-success="handleImagesSuccess"
                               :before-upload="beforeAvatarUpload">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="状态" prop="isMarketable">
                    <el-radio-group v-model="editForm.isMarketable">
                        <el-radio :label="true">上架</el-radio>
                        <el-radio :label="false">下架</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="类型" prop="goodsType">
                    <el-radio-group v-model="editForm.goodsType">
                        <el-radio :label="1">普通商品</el-radio>
                        <el-radio :label="2">接龙商品</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker v-model="editForm.startTime"
                                    type="datetime"
                                    placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker v-model="editForm.endTime"
                                    type="datetime"
                                    placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="规格" prop="spec">
                    <el-input v-model="editForm.spec" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="产地" prop="place">
                    <el-input v-model="editForm.place" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="包装" prop="packing">
                    <el-input v-model="editForm.packing" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="商品详情" prop="intro">
                    <Tinymce v-if="editFormVisible" ref="editor" v-model="editForm.intro" :height="500" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary"
                           @click.native="editSubmit"
                           :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import {
        getRoleListPage,
        getGoodsListPage,
        getGoodsCategoryTree,
        addGoods,
        getGoods,
        editGoods,
        putOnGoods,
        putOffGoods,
        removeGoods,
        getStoreSelectList,
        //exportGoodsList,
    } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    import Toolbar from "../../components/Toolbar";
    import Tinymce from '@/components/Tinymce'

    export default {
        components: { Toolbar, Tinymce },
        data() {
            return {
                filters: {
                    name: "",
                },
                datalist: [],
                roles: [],
                categorys: [],
                total: 0,
                buttonList: [],
                currentRow: null,
                page: 1,
                limit: 10,
                listLoading: false,
                sels: [], //列表选中列
                addDialogFormVisible: false,

                //新增界面配置信息
                addFormVisible: false, //新增界面是否显示
                addLoading: false,
                addFormRules: {
                    storeName: [{ required: true, message: "请输入店铺名称", trigger: "blur" },],
                    //type: [{ required: true, message: "请选择店铺类型", trigger: "blur" }],
                },
                addForm: {},//新增界面数据

                //编辑界面配置信息
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    storeName: [{ required: true, message: "请输入店铺名称", trigger: "blur" },],
                },
                editForm: {},//编辑界面数据
                isResouceShow: 0,

                ///图片上传
                ///头像url
                imageUrl: '',
                fileList: [],
                ///弹窗图片
                dialogImageUrl: '',
                dialogVisible: false,

                ///店铺列表
                //options: [
                //    {
                //        value: 1, label: '苹果专卖店'
                //    }, {
                //        value: 2, label: '华为手机专卖店'
                //    }, {
                //        value: 3, label: '我爱我家地产中介'
                //    }, {
                //        value: 4,label: '鑫旺超市'
                //    }, {
                //        value: 5,label: '好客来超市'
                //    }],
                storeSeletctList: [],
                value: [],
            };
        },
        methods: {
            selectCurrentRow(val) {
                this.currentRow = val;
            },
            callFunction(item) {
                this.filters = {
                    name: item.search,
                };
                this[item.func].apply(this, item);
            },
            handSearch() {
                this.handleCurrentChange(0);
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getGoodss();
            },
            //获取店铺列表
            getGoodss() {
                let para = {
                    page: this.page,
                    key: this.filters.name,
                    orderField: "sort",
                    orderDirection: "asc",
                };
                this.listLoading = true;
                getGoodsListPage(para).then((res) => {
                    console.log(res);
                    this.total = res.data.count;
                    this.datalist = res.data.data;
                    this.listLoading = false;
                });
            },

            //导出表格
            exportExcel() { },


            //************按钮事件************
            //删除
            handleDel() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要删除的店铺！",
                        type: "error",
                    });
                    return;
                }
                this.$confirm("确认删除该店铺吗?", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = { id: row.id };
                        removeGoods(para).then((res) => {
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.code == 0) {
                                this.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }
                            this.getGoodss();
                        });
                    })
                    .catch(() => { });
            },

            //上架
            handlePutOn() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要上架该商品！",
                        type: "error",
                    });
                    return;
                }
                this.$confirm("确认上架该商品吗?", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        this.listLoading = true;
                        let para = { id: row.id };
                        putOnGoods(para).then((res) => {
                            this.listLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: "上架成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }
                            this.getGoodss();
                        });
                    })
                    .catch(() => { });
            },

            //上架
            handlePutOff() {
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要下架该商品！",
                        type: "error",
                    });
                    return;
                }
                this.$confirm("确认下架该商品吗?", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        this.listLoading = true;
                        let para = { id: row.id };
                        putOffGoods(para).then((res) => {
                            this.listLoading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: "下架成功",
                                    type: "success",
                                });
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }
                            this.getGoodss();
                        });
                    })
                    .catch(() => { });
            },

            //显示新增界面
            handleAdd() {
                console.log(this.storeSeletctList);
                let that = this;
                that.fileList = [];
                that.imageUrl = "";
                getGoodsCategoryTree({}).then((res) => {
                    if (res.data.code == 0) {
                        that.categorys = [];
                        that.categorys.push(res.data.data);
                        that.addFormVisible = true;
                    }
                    this.addLoading = false;
                    //tinymce.init({});
                });
            },

            //显示编辑界面
            handleEdit() {
                let that = this;
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                        message: "请选择要编辑的商品！",
                        type: "error",
                    });
                    return;
                }
                //tinymce.init({});
                getGoods({ id: row.id }).then((res) => {
                    if (res.code == 0) {
                        console.log(res.data);
                        that.editForm = res.data;
                        that.imageUrl = res.data.image;
                        that.fileList = [];
                        if (res.data.imageList != undefined) {
                            for (var i = 0; i < res.data.imageList.length; i++) {
                                var ii = { name: res.data.imageList[i], url: res.data.imageList[i] };
                                that.fileList.push(ii);
                            }
                        }
                        console.log(that.fileList);
                    }
                });
                getGoodsCategoryTree({}).then((res) => {
                    if (res.data.code == 0) {
                        that.categorys = [];
                        that.categorys.push(res.data.data);
                    }
                });
                this.editLoading = false;
                that.editFormVisible = true;
            },
            handleChange(value) {
                console.log(value);
            },

            //************提交方法************

            //新增
            addSubmit: function () {
                console.log("1");
                console.log(this.addForm);
                console.log("2");
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.addLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            if (para.categoryIdArr != undefined) {
                                para.categoryId = para.categoryIdArr.pop();
                            }
                            para.intro = tinymce.activeEditor.getContent();
                            para.image = this.imageUrl;
                            var imageList = [];
                            for (var i = 0; i < this.fileList.length; i++) {
                                imageList.push(this.fileList[i].url);
                            }
                            para.imageList = imageList;
                            addGoods(para).then((res) => {
                                if (res.code == 0) {
                                    this.addLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.msg,
                                        type: "success",
                                    });
                                    this.$refs["addForm"].resetFields();
                                    this.addFormVisible = false;
                                    this.getGoodss();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: "error",
                                    });
                                }
                            });
                        });
                    }
                });
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            let para = Object.assign({}, this.editForm);
                            if (para.categoryIdArr != undefined) {
                                para.categoryId = para.categoryIdArr.pop();
                            }
                            para.image = this.imageUrl;
                            var imageList = [];
                            for (var i = 0; i < this.fileList.length; i++) {
                                imageList.push(this.fileList[i].url);
                            }
                            para.imageList = imageList;
                            para.intro = tinymce.activeEditor.getContent();
                            editGoods(para).then((res) => {
                                if (res.code == 0) {
                                    this.editLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.msg,
                                        type: "success",
                                    });
                                    this.$refs["editForm"].resetFields();
                                    this.editFormVisible = false;
                                    this.getGoodss();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: "error",
                                    });
                                }
                            });
                        });
                    }
                });
            },

            selsChange: function (sels) {
                this.sels = sels;
            },

            handleAvatarSuccess(res, file) {
                console.log(res);
                console.log(file.raw);
                //this.imageUrl = "https://younong.haichuangyibai.com/upload/compress/0a7f3ae2-d23e-4716-b4f6-95c0b6f60f25.jpg";
                this.imageUrl = res.data.src;
                //this.imageUrl = res.data.src;
                //this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },

            handleImagesSuccess(res, file) {
                console.log(res);
                console.log(file.raw);
                if (this.fileList == undefined) {
                    this.fileList = [];
                }
                this.fileList.push({ name: res.data.src, url: res.data.src });
                //this.imageList.push({ name: "", url: "https://younong.haichuangyibai.com/upload/compress/0a7f3ae2-d23e-4716-b4f6-95c0b6f60f25.jpg" });
                //this.imageList.push(res.data.src);
                //console.log(this.imageList);
                //this.imageUrl = res.data.src;
                //this.imageUrl = URL.createObjectURL(file.raw);
            },
            handleRemove(file, fileList) {
                this.fileList = fileList;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },

            //获取店铺列表
            getStoreSelectList() {
                getStoreSelectList({ data: 0 }).then((res) => {
                    console.log("11111");
                    console.log(res);
                    this.storeSeletctList = res.data;
                });
            },
        },
        mounted() {
            this.getGoodss();
            this.getStoreSelectList();

            getRoleListPage().then((res) => {
                this.roles = res.data.data;
            });
            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            this.buttonList = getButtonList(this.$route.path, routers);
        },
    };
</script>

<style scoped>
</style>
